import {
  useProjectsQuery,
  Project,
} from "@/features/projects/graphql/generated";

export const usePositions = (orgId: number, personId?: number) => {
  const { data, loading } = useProjectsQuery({
    variables: {
      filter: {
        org_id: orgId,
        person_id: personId,
      },
    },
    skip: !orgId,
  });

  const positions = (data?.projects || []) as Project[];

  return {
    positions,
    loading,
  };
};
